import { fabric } from 'fabric';
import ToolOption from '../common/ToolOption';
import { CanvasEventType, GraphType } from '../constants/Constants';
import UndoManager from '../manager/UndoManager';
import log from 'loglevel';
import Graphic from './Graphic';

/**
 * 画笔
 *
 * @export
 * @class CanvasPen
 * @extends {Graphic}
 */
export default class CanvasPen extends Graphic {
  constructor(app) {
    super(app);
    this.e = {
      // [CanvasEventType.Add]: this._add.bind(this)
      [CanvasEventType.Add]: this.app.items._addByHand.bind(this.app)
    };
  }

  set option(val) {
    super.option = val;

    if (!val) {
      this._option = this.defaultOption;
    }

    Object.assign(this._option, val);
    let brush = this.root.freeDrawingBrush;
    brush.color = this._option.stroke;
    brush.width = Math.max(this._option.strokeWidth, 1); // 画笔宽度至少为1
    brush.shadow = null;
  }

  get option() {
    return this._option;
  }

  get defaultOption() {
    return new ToolOption();
  }

  addEvents() {
    super.addEvents();
    this.root.isDrawingMode = true;

    if (
      !this.root.__eventListeners[CanvasEventType.Add] ||
      this.root.__eventListeners[CanvasEventType.Add].length === 0 ||
      this.root.__eventListeners[CanvasEventType.Add].findIndex(item => {
        return typeof item === 'function';
      }) === -1
    ) {
      this.root.on(CanvasEventType.Add, this.e[CanvasEventType.Add]);
    }
  }

  removeEvents() {
    super.removeEvents();
    this.root.isDrawingMode = false;
    if (this.root.__eventListeners[CanvasEventType.Add]?.length) {
      this.root.off(CanvasEventType.Add);
    }
  }

  _add(e) {
    log.info('add', e);
    if (!e.target) {
      return;
    }

    let pen = e.target;
    let data = this.factory.createAddData(pen);
    // MsgSender.add(data)
    this.app.sender.add(data);
    let allData = this.app.stage.root.toDatalessJSON();
    UndoManager.getInstance().save(allData);
  }

  static toAddData(target) {
    let obj = Graphic.toAddData(target);
    if (target.type !== 'path') {
      return obj;
    }

    obj.gtype = GraphType.PEN;
    if (target.path.length <= 5) {
      obj.path = target.path;
      return obj;
    }

    let pa = [];
    let a = [];

    target.path.forEach((path, index, arr) => {
      // // 减少数据量
      if (index === 0 || index === arr.length - 1 || index % 3 === 1) {
        path.every(p => {
          if (!isNaN(parseFloat(p))) {
            p = fabric.util.toFixed(p, 1);
            a.push(p);
          } else {
            a.push(p);
          }
          return true;
        });
        pa.push(a);
        a = [];
      }
    });

    obj.path = pa;
    /*
    // 如果直接修改原始数据，画不上了就
    let arr = JSON.parse(JSON.stringify(target.path)); // 如果有性能问题， 就再说吧。
    let res = [];

    // [[M x,y],[Q x1,y1,x2,y2],[Q x1,y1,x2,y2],[L x, y]]
    arr.forEach(ele => {
      ele.shift();
      if (ele.length % 2 === 0) {
        for (let i = 0; i < ele.length;) {
          res.push([parseFloat(ele[i].toFixed(1)), parseFloat(ele[i + 1].toFixed(1))]);
          i += 2;
        }
      }
    });
    obj.path = res;
    // obj.fill = target.fill; // #ffffff, transparent, none, ''等
    */
    return obj;
  }
}
